import {Component, Input, input, ChangeDetectionStrategy} from '@angular/core';

import {Survey} from '../../../api/models/survey';
import {User} from '../../../api/models/user';
import {CorrectionListComponent} from './correction-list/correction-list.component';
import {WaCalloutDirective, WaDividerDirective, WaIconDirective} from "angular-awesome";
import {SupervisionListComponent} from "./supervision-list/supervision-list.component";

@Component({
  selector: 'app-survey-assignment',
  templateUrl: './survey-assignment.component.html',
  styleUrls: ['./survey-assignment.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SupervisionListComponent, CorrectionListComponent, WaCalloutDirective, WaIconDirective, WaDividerDirective]
})
export class SurveyAssignmentComponent {

  readonly user = input<User | null>(null);
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() survey: Survey | null = null;

  constructor() {}
}
